<template lang="html">
  <div class="textarea" :class="{ 'textarea--error': isError }">
    <div class="textarea__label" v-if="label">{{ label }}</div>
    <textarea
      :maxlength="maxlength"
      v-model="model"
      :placeholder="placeholder"
      @focus="inputFocus"
    ></textarea>
    <span class="textarea__error-message" v-if="isError && errorMessage">{{
      errorMessage
    }}</span>

    <SimpleKeyboard
      v-if="keyboardIsOpen"
      :placeholder="placeholder"
      :input="modelValue"
      @close="keyboardClose"
      @onChange="onChange"
      @onKeyPress="onKeyPress"
    />
  </div>
</template>

<script>
import SimpleKeyboard from '@/components/SimpleKeyboard.vue';

export default {
  name: 'Textarea',
  components: { SimpleKeyboard },
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    isError: {
      type: Boolean,
      required: false,
    },
    maxlength: {
      type: Number,
      required: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      uniqId: null,
    };
  },
  computed: {
    keyboardIsOpen() {
      return (
        this.$store.state.global.inHouse &&
        this.uniqId === this.$store.state.global.keyboardUniqID
      );
    },
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
  mounted() {
    this.uniqId = Math.random().toString(16).slice(2);
  },
  methods: {
    inputFocus() {
      this.$store.commit('global/changeInputFocus', this.uniqId);
    },
    onChange(input) {
      this.$emit('update:modelValue', input);
    },
    onKeyPress(button) {
      console.log('button', button);
    },
    keyboardClose() {
      this.$store.commit('global/changeInputFocus', null);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'styles';
</style>
